import React, { useState } from 'react';
import styled from 'styled-components';
import ProjectManager from '../components/Admin/ProjectManager';

const AdminPageContainer = styled.div`
  padding-top: 80px; // Account for header
  min-height: 100vh;
  background-color: ${props => props.theme.colors.offWhite};
`;

const AdminHeader = styled.div`
  background-color: ${props => props.theme.colors.darkGray};
  color: ${props => props.theme.colors.white};
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
`;

const AdminTitle = styled.h1`
  font-size: 2rem;
  margin: 0;
`;

const ContentContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
`;

const TabsContainer = styled.div`
  display: flex;
  margin-bottom: 2rem;
  border-bottom: 1px solid ${props => props.theme.colors.lightGray};
`;

const Tab = styled.button`
  padding: 1rem 2rem;
  background-color: ${props => props.active 
    ? props.theme.colors.white 
    : 'transparent'};
  color: ${props => props.active 
    ? props.theme.colors.accent 
    : props.theme.colors.gray};
  border: none;
  border-bottom: 3px solid ${props => props.active 
    ? props.theme.colors.accent 
    : 'transparent'};
  cursor: pointer;
  font-weight: 500;
  font-size: ${props => props.theme.fontSizes.medium};
  transition: all ${props => props.theme.transitions.short};
  
  &:hover {
    color: ${props => props.theme.colors.accent};
  }
`;

const Admin = () => {
  const [activeTab, setActiveTab] = useState('projects');
  
  return (
    <AdminPageContainer>
      <AdminHeader>
        <AdminTitle>Admin Dashboard</AdminTitle>
      </AdminHeader>
      
      <ContentContainer>
        <TabsContainer>
          <Tab 
            active={activeTab === 'projects'} 
            onClick={() => setActiveTab('projects')}
          >
            Projects
          </Tab>
          <Tab 
            active={activeTab === 'settings'} 
            onClick={() => setActiveTab('settings')}
          >
            Settings
          </Tab>
        </TabsContainer>
        
        {activeTab === 'projects' && <ProjectManager />}
        {activeTab === 'settings' && (
          <div>
            <h2>Settings</h2>
            <p>Website settings go here.</p>
          </div>
        )}
      </ContentContainer>
    </AdminPageContainer>
  );
};

export default Admin; 